(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-dock"] && !Shopify.designMode) return;
  try {
    class MobileDock extends HTMLElement {
    connectedCallback() {
      this.menuButton = this.querySelector('[data-mobile-dock-menu]');
      this.toggleButton = this.querySelector('[data-mobile-dock-toggle]');
      this.openMenu = () => {
        const drawer = document.querySelector('#Details-menu-drawer-container');
        const trigger = drawer?.querySelector(':scope > summary');
        if (trigger && !drawer.open) trigger.click();
      };
      this.toggleDock = () => {
        const expanded = this.dataset.expanded !== 'true';
        this.dataset.expanded = String(expanded);
        this.toggleButton?.setAttribute('aria-expanded', String(expanded));
      };
      this.syncStickyOffset = () => {
        const stickyBar = document.querySelector('.sticky-add-to-cart__bar');
        if (stickyBar !== this.stickyBar) {
          if (this.stickyBar) this.resizeObserver?.unobserve(this.stickyBar);
          this.stickyBar = stickyBar;
          if (this.stickyBar) this.resizeObserver?.observe(this.stickyBar);
        }
        const stickyStyles = this.stickyBar ? getComputedStyle(this.stickyBar) : null;
        const isVisible =
          this.stickyBar?.dataset.stuck === 'true' &&
          stickyStyles?.display !== 'none' &&
          stickyStyles?.visibility !== 'hidden';
        const height = isVisible ? Math.ceil(this.stickyBar.getBoundingClientRect().height) : 0;
        this.style.setProperty('--mobile-dock-sticky-height', `${height}px`);
      };
      this.menuButton?.addEventListener('click', this.openMenu);
      this.toggleButton?.addEventListener('click', this.toggleDock);
      if (this.hasAttribute('data-product-page')) {
        this.resizeObserver = new ResizeObserver(this.syncStickyOffset);
        this.stickyObserver = new MutationObserver(this.syncStickyOffset);
        this.stickyObserver.observe(document.body, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['data-stuck'],
        });
        this.syncStickyOffset();
      }
    }

    disconnectedCallback() {
      this.menuButton?.removeEventListener('click', this.openMenu);
      this.toggleButton?.removeEventListener('click', this.toggleDock);
      this.resizeObserver?.disconnect();
      this.stickyObserver?.disconnect();
    }
  }

  if (!customElements.get('mobile-dock')) customElements.define('mobile-dock', MobileDock);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rocketz-cashback-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rocketz-cashback-estimate')) {
    customElements.define(
      'rocketz-cashback-estimate',
      class extends HTMLElement {
        connectedCallback() {
          this.renderEstimate();
        }

        async renderEstimate() {
          if (this.dataset.enabled !== 'true') return;
          const amount = Math.max(0, Number(this.dataset.amount || 0) / 100);
          if (!amount) return;
          try {
            const response = await fetch(
              `/apps/rocketz-license/cashback/estimate?amount=${Math.round(amount * 100)}`,
              { headers: { accept: 'application/json' } },
            );
            if (!response.ok) return;
            const config = await response.json();
            if (!config.enabled || !config.rewardAmount) return;
            const currency = this.dataset.currency || 'USD';
            const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency,
            }).format(config.rewardAmount);
            this.querySelector('[data-cashback-message]').textContent = (
              this.dataset.message || 'Earn __amount__ cashback'
            ).replace('__amount__', formatted);
            this.querySelector('[data-cashback-delay]').textContent = (
              this.dataset.delay || 'Available after __days__ days'
            ).replace('__days__', String(config.holdDays));
            this.hidden = false;
          } catch (_error) {
            this.hidden = true;
          }
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
